import React, { useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  Box,
  Grid,
  Typography,
  Button,
  styled,
  CircularProgress,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { FaFileAlt } from "react-icons/fa"; // Icon for "View Resume"
import { customTextColor, shortDateTime } from "../../utils/const";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch, useSelector } from "react-redux";
import { getCandidate } from "../../redux/hotlist/hotListSlice";
import EditCandidateDrawer from "./EditCandidateDrawer";
import { allSkill } from "../../redux/common/skillSlice";

// Static dummy data to match the image
const candidateData = {
  title: "No record found since 12 JAN 2025",
  name: "Mark Davis",
  jobProfile: ".Net Developer",
  experience: "10 Years",
  phone: "+1 242 550 7201",
  email: "markdevis.dev@gmail.com",
  location: "Kolkata, KK",
  willingToRelocate: "Not willing to relocate",
  employmentType: "Contract",
  rate: "$70 Hourly",
  visa: "H1B",
  recentProject: "TCS",
  ssn_no: "7401",
  //   recentProject: "TCS",
  primarySkills:
    "Visual SQL Server / PostgreSQL / MySQL Entity Framework (EF) ASP.NET MVC / Razor Pages RESTful APIs with ASP.NET Core Azure: Microsoft's cloud, xUnit, NUnit, .NET Core / .NET 5+",
  secondarySkills:
    "MySQL Entity Framework (EF) ASP.NET MVC / Razor Pages RESTful APIs with ASP.NET Core Azure: Microsoft's cloud, xUnit, NUnit, .NET Core / .NET 5+",
};

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#d0d0f0",
  },
}));

const ViewCandidateDrawer = ({ show, handleClose, selectedCandidate }) => {
  const dispatch = useDispatch();

  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const candidateDetails = useSelector((state) => state.hotlist);
  const skillData = useSelector((state) => state.skill.data);
  const { candidateDetail } = candidateDetails;
  const { loading } = candidateDetails;

  console.log("candidateDetail", candidateDetail, loading?.getCandidate);

  useEffect(() => {
    if (selectedCandidate?.id) {
      dispatch(getCandidate(selectedCandidate?.id));
      dispatch(allSkill());
    }
  }, [dispatch, selectedCandidate?.id]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };
  const getSkillNamesByIds = (skillIds) => {
    return (
      skillData?.locations
        ?.filter((skill) => skillIds?.includes(skill.id))
        .map((skill) => skill.name)
        .join(", ") || ""
    );
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 10px",
              //   borderBottom: "1px solid #e0e0e0",
              mb: 2,
            }}
          >
            <Typography
              style={{
                color: customTextColor,
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              No record found since {shortDateTime(candidateDetail?.updated_at)}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {candidateDetail?.resume ? (
                <>
                  View Resume{" "}
                  <a
                    href={candidateDetail?.resume}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ActionButton
                      color="inherit"
                      sx={{
                        backgroundColor: "#deebf7",
                        borderRadius: "3px",
                        padding: "3px",
                        "&:hover": {
                          backgroundColor: "#33a8c7",
                        },
                      }}
                    >
                      <Icon
                        icon="material-symbols-light:docs-outline-rounded"
                        width="25px"
                        height="25px"
                        color="black"
                      />
                    </ActionButton>
                  </a>
                </>
              ) : (
                "No Resume"
              )}

              <RxCross2
                style={{
                  fontSize: "15px",
                  cursor: "pointer",
                  color: customTextColor,
                }}
                onClick={handleClose}
              />
            </Box>
          </Box>
          {loading?.getCandidate === "pending" && (
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 2, py: 5 }}
            >
              {" "}
              <CircularProgress />
            </Box>
          )}
          {loading?.getCandidate !== "pending" && (
            <Grid container sx={{ padding: "10px" }}>
              {/* Left Column: Name, Experience, Email, Willing to Relocate, Rate */}
              <Grid item xs={6}>
                <ul
                  style={{
                    listStyleType: "square",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.full_name}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.total_experience < 1
                        ? `${Math.round(
                            candidateDetail?.total_experience * 12
                          )} Months`
                        : `${candidateDetail?.total_experience} ${
                            candidateDetail?.total_experience === 1
                              ? "Year"
                              : "Years"
                          }`}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.email}
                    </Typography>
                  </li>

                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      ${candidateDetail?.rate} Hourly
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.last_project}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.willing_to_relocate
                        ? "Willing to Relocate"
                        : "Not Willing to Relocate"}
                    </Typography>
                  </li>
                </ul>
              </Grid>

              {/* Right Column: Job Profile, Phone, Location, Employment Type, Visa, Recent Project */}
              <Grid item xs={6}>
                <ul
                  style={{
                    listStyleType: "square",
                    paddingLeft: "20px",
                    margin: 0,
                  }}
                >
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.current_job_title}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.mobile_no}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.current_location &&
                        getLocationById(candidateDetail?.current_location)}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.p_tax_team || "Contract"}
                    </Typography>
                  </li>
                  <li>
                    <Typography style={{ fontSize: "14px" }}>
                      {candidateDetail?.work_authorization &&
                        getWorkAuthorization(
                          candidateDetail?.work_authorization
                        )}{" "}
                    </Typography>
                  </li>
                  {candidateDetail?.prefer_location?.length > 0 && (
                    <li>
                      <Typography style={{ fontSize: "14px" }}>
                        {getPreferLocationNames(
                          candidateDetail?.prefer_location
                        )}
                      </Typography>
                    </li>
                  )}
                </ul>
              </Grid>
            </Grid>
          )}

          {/* Primary Skills Section */}
          {loading?.getCandidate !== "pending" && (
            <>
              <Box sx={{ padding: "10px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                    textTransform: "uppercase",
                  }}
                >
                  Primary Skills
                </Typography>
                <Typography style={{ fontSize: "14px" }}>
                  {getSkillNamesByIds(candidateDetail?.primary_skills)}
                </Typography>
              </Box>

              <Box sx={{ padding: "10px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                    textTransform: "uppercase",
                  }}
                >
                  Secondary Skills
                </Typography>
                <Typography style={{ fontSize: "14px" }}>
                  {getSkillNamesByIds(candidateDetail?.secondary_skills)}
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewCandidateDrawer;
